import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params }     from '@angular/router';
import { OnboardingService } from '../onboarding.service';
import { LoaderService } from '../../utils/loader.service';

@Component({
  selector: 'app-submitted',
  templateUrl: './submitted.component.html',
  styleUrls: ['./submitted.component.scss']
})
export class SubmittedComponent implements OnInit {

  constructor(
    private router: Router,
    public onboardingService: OnboardingService,
    private loaderService: LoaderService,
  ) { 
    if(localStorage.getItem('is_approved') == "true"){
      this.router.navigate(['/admin/dashboard']);
    }else if(localStorage.getItem('has_onboarded') != "true"){
      this.router.navigate(['/onboarding']);
    }
  }

  ngOnInit() {
  }


  dashboard(){
    this.router.navigate(['/admin/dashboard'])
  }
}
